import React from "react";
import Layout from "../shared/components/Layout";
import SubPageHeroSection from "../shared/sections/SubPageHeroSection";
import ContactSection from "../shared/sections/ContactSection";
import BlogListSection from "../shared/sections/BlogListSection";

const BlogsList = () => {
	return (
		<Layout banner={<SubPageHeroSection title="Blogs List" />}>
			<BlogListSection noHead />
			<ContactSection />
		</Layout>
	);
};

export default BlogsList;
